import React from 'react';
import './SignupError.scss';
import errorIcon from '../../../assets/icons/error_icon.svg';
import { Routes, SandboxRoutes } from '../../../app/AppRouter';
import { useHistory } from 'react-router';

type Props = {
  sandbox: boolean;
};

export const SignupError: React.FC<Props> = ({ sandbox }) => {
  const history = useHistory();

  const onDone = () => {
    history.push(sandbox ? SandboxRoutes.home : Routes.home);
  };

  return (
    <div className={'hatters-flex-column-container'}>
      <span className={'flex-spacer-small'} />

      <img src={errorIcon} className={'signup-error-icon'} alt={'Signup error icon'} />

      <div className={'hatters-title signup-error-title'}>Oh no!</div>

      <div className={'hatters-description-normal signup-error-description'}>
        We ran into some technical trouble when creating your HAT PDA. Your information has not been taken. Please try
        again later!
      </div>

      <button className="hatters-btn hatters-btn-accent signup-error-btn" onClick={onDone}>
        OK
      </button>

      <span className={'flex-spacer-large'} />
    </div>
  );
};
